import { Legend } from "@rio-cloud/rio-uikit";
import Bar from "@rio-cloud/rio-uikit/Bar";
import BarChart from "@rio-cloud/rio-uikit/BarChart";
import type { ExtractData } from "./types/types";

export type InfractionChartProps = {
  epkScore: ExtractData["epkScore"];
};

export function InfractionChart({ epkScore }: InfractionChartProps) {
  return (
    <div className="panel panel-default panel-body margin-bottom-0 height-300">
      <BarChart
        data={[
          {
            "Conformidade": epkScore,
            Oportunidades: 100 - epkScore,
          },
        ]}
        xAxisOptions={{ label: "Proporção de eventos" }}
        yAxisOptions={{
          domain: [0, 100],
          ticks: [0, 20, 40, 60, 80, 100],
        }}
        showYAxis
        showGrid
        dataUnit="%"
        margin={{ bottom: 16, top: 16 }}
        barGap={16}
        barSize={72}
        legend={
          <Legend layout="horizontal" verticalAlign="bottom" align="center" />
        }
        bars={[
          <Bar
            key="accordance"
            dataKey="Conformidade"
            color="color-coldplay-fountain"
          />,
          <Bar
            key="opportunities"
            dataKey="Oportunidades"
            color="color-rating-2"
          />,
        ]}
      />
    </div>
  );
}
